
import { defineComponent } from 'vue'

export default defineComponent({
    data() {
        return {
            signageItemLayoutData: {} as any,      
            playSound: false
        }
    },

    props: {
        layoutDataEdit: {
            type: Object,
            default: null
        },
        playSoundEdit: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        isUrlValid(): boolean {
           const regex = new RegExp("^(https?:\\/\\/)?(www\\.)?(youtube\\.com\\/(watch\\?(.*&)?v=|shorts\\/|live\\/)|youtu\\.be\\/)([a-zA-Z0-9_-]{11})");       
            if(regex.test(this.signageItemLayoutData.url)) {
                return true;
            }
            return false;
        },
    },

    created () {
        this.signageItemLayoutData = JSON.parse(JSON.stringify(this.layoutDataEdit));
        this.playSound = this.playSoundEdit;
        this.$emit('isUrlValid', this.isUrlValid);
    },

    methods: {
        selectAllText(nativeInput: HTMLInputElement) {
            // Use setTimeout to work around Safari's selection quirk
            setTimeout(() => {
                nativeInput.select();
                // Double-select for Safari to ensure it sticks
                setTimeout(() => {
                    if (nativeInput === document.activeElement) {
                        nativeInput.setSelectionRange(0, nativeInput.value.length);
                    }
                }, 10);
            }, 0);
        },
        handleMouseDown(event: MouseEvent) {
            const input = this.$refs.urlInput as any;
            if (input && input.$el) {
                const nativeInput = input.$el.querySelector('input');
                if (nativeInput) {
                    const isAlreadyFocused = nativeInput === document.activeElement;
                    
                    if (!isAlreadyFocused) {
                        event.preventDefault();
                        nativeInput.focus();
                    }
                    
                    this.selectAllText(nativeInput);
                }
            }
        },
        selectAllUrl() {
            const input = this.$refs.urlInput as any;
            if (input && input.$el) {
                const nativeInput = input.$el.querySelector('input');
                if (nativeInput) {
                    this.selectAllText(nativeInput);
                }
            }
        }
    },

    watch: {
        'signageItemLayoutData': {
            handler(newValue: any){
                if(this.isUrlValid)
                    this.$emit('updateLayoutData', {updatedLayoutData: newValue, shouldUpdatePreview: false});
            },
            deep: true
        },
        'playSound': {
            handler(newValue: any){
                this.$emit('updatePlaySound', newValue);
            },
        },
        'isUrlValid': {
            handler(newValue: boolean){
                this.$emit('isUrlValid', newValue);
            },
        },
    }
})
